
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[authorID]/batches",
      function () {
        return require("private-next-pages/[authorID]/batches.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[authorID]/batches"])
      });
    }
  